<template>
  <!-- 产融科技 -->
  <div>
    <div class="crTechnology-top">
      <div>
        物润产融科技
        <p>基于数字化产融平台，通过构建司机、车辆、运单、发货人及收货人5大画像、</p>
        <p>
          智慧风控驾驶舱、供应链1+N+1结构穿透，实现数据资产化，使资产更加真实、可靠、及时。
        </p>
      </div>
    </div>
    <!-- 五大画像 -->
    <!-- <div class="WuDaHuax">
      <p class="Title">五大画像</p>
      <div class="div">
        <div class="div0"></div>
        <div class="div1">
          <div class="div1-1">
            <img src="../../assets/crTechnology/wdhx-sij.png" alt="" />
            <p>司机</p>
          </div>
          <div class="div1-2">
            <ul>
              <li>姓名</li>
              <li>年龄</li>
              <li>驾龄</li>
              <li>身份证号</li>
              <li>驾驶证号</li>
              <li>准驾车型</li>
              <li>从业资格证号</li>
              <li>货损</li>
              <li>货差</li>
              <li>月接单量</li>
              <li>月均里程</li>
              <li>月均登录次数</li>
              <li>常跑线路</li>
              <li>常驾车牌</li>
            </ul>
          </div>
        </div>
        <div class="div1">
          <div class="div1-1">
            <img src="../../assets/crTechnology/wdhx-chel.png" alt="" />
            <p>车辆</p>
          </div>
          <div class="div1-2">
            <ul>
              <li>车牌号</li>
              <li>车辆颜色</li>
              <li>车辆总质量</li>
              <li>整备质量</li>
              <li>核定载质量</li>
              <li>车辆类型</li>
              <li>牌照类型</li>
              <li>车辆所有人</li>
              <li>车辆试别代号</li>
              <li>车辆行驶证档案编号</li>
              <li>行驶证注册日期</li>
              <li>行驶证发证日期</li>
              <li>行驶证到期日期</li>
              <li>道路运输证字号</li>
              <li>道路运输证到期日期</li>
              <li>业户类型</li>
              <li>所属辖区</li>
            </ul>
          </div>
        </div>
        <div class="div1">
          <div class="div1-1">
            <img src="../../assets/crTechnology/wdhx-yund.png" alt="" />
            <p>运单</p>
          </div>
          <div class="div1-2">
            <ul>
              <li>运单号</li>
              <li>发货人</li>
              <li>收货人</li>
              <li>承运人</li>
              <li>司机</li>
              <li>车辆</li>
              <li style="font-size: 14px;">（车牌、车型、轨迹）</li>
              <li>装货地</li>
              <li>卸货地</li>
              <li>装车时间</li>
              <li>到货时间</li>
              <li>签收时间</li>
              <li>货物信息</li>
              <li style="font-size: 14px;">(型号、重量、单位、单价、金额)</li>
              <li>货物保单</li>
              <li>发票信息</li>
              <li>运费信息</li>
            </ul>
          </div>
        </div>
        <div class="div1">
          <div class="div1-1">
            <img src="../../assets/crTechnology/wdhx-fahr.png" alt="" />
            <p>发货人</p>
          </div>
          <div class="div1-2">
            <ul>
              <li>企业名称</li>
              <li>统一社会信用代码</li>
              <li>注册资金</li>
              <li>注册地址</li>
              <li>办公地址</li>
              <li>成立时间</li>
              <li>经营期限</li>
              <li>经营状态</li>
              <li>法人代表</li>
              <li>实际控制人</li>
              <li>公司类型</li>
              <li>所属行业</li>
              <li>税务等级</li>
              <li>常用发货地</li>
              <li>月均发货数量</li>
              <li style="font-size: 14px;">（件、吨、立方）</li>
              <li>月均发货单量</li>
              <li>月均发货金额</li>
              <li>月均支付运费</li>
              <li>月销项票总数</li>
              <li>月销项票金额</li>
            </ul>
          </div>
        </div>
        <div class="div1">
          <div class="div1-1">
            <img src="../../assets/crTechnology/wdhx-shouhr.png" alt="" />
            <p>收货人</p>
          </div>
          <div class="div1-2">
            <ul>
              <li>企业名称</li>
              <li>统一社会信用代码</li>
              <li>注册资金</li>
              <li>注册地址</li>
              <li>办公地址</li>
              <li>成立时间</li>
              <li>经营期限</li>
              <li>经营状态</li>
              <li>法人代表</li>
              <li>实际控制人</li>
              <li>公司类型</li>
              <li>所属行业</li>
              <li>税务等级</li>
              <li>常用收货地</li>
              <li>月均收货数量</li>
              <li style="font-size: 14px;">（件、吨、立方）</li>
              <li>月均收货单量</li>
              <li>月均收货金额</li>
              <li>月均支付运费</li>
              <li>月进项票总数</li>
              <li>月进项票金额</li>
            </ul>
          </div>
        </div>
        <div class="div0"></div>
      </div>
    </div> -->
    <div class="WuDaHuax">
      <p class="Title">五大画像</p>
      <div class="div">
        <div class="div0 div1"></div>
        <div class="div0 div2">
          <div class="partner" v-for="(item, i) in partners" :key="i">
            <el-image
              :src="item.url"
            >
            </el-image>
          </div>
        </div>
        <div class="div0 div6"></div>
      </div>
    </div>
    <!-- 产融科技八大核心能力 -->
    <div class="crkjBdHxnl">
      <p class="Title">产融科技八大核心能力</p>
      <div class="div">
        <div class="div0 div1"></div>
        <div class="div0 div2"></div>
        <div class="div0 div6"></div>
      </div>
    </div>
    <!-- 供应链1+N+1结构穿透 -->
    <div class="gylJiaJgct">
      <p class="Title">供应链1+N+1结构穿透</p>
      <div class="div">
        <div class="div0 div1"></div>
        <div class="div0 div2"></div>
        <div class="div0 div6"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
    data() {
    return {
      partners: [
        { url: require("../../assets/crTechnology/portrait-one.png") },
        { url: require("../../assets/crTechnology/portrait-two.png") },
        { url: require("../../assets/crTechnology/portrait-three.png") },
        { url: require("../../assets/crTechnology/portrait-four.png") },
        { url: require("../../assets/crTechnology/portrait-five.png") },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
/* 顶部背景图开始 */
.crTechnology-top {
  background: url("../../assets/crTechnology/technology-banner.png") center center
    no-repeat;
  height: 665px;
  display: flex;
}
.crTechnology-top div {
  margin: auto;
  font-size: 56px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 128px;
}
.crTechnology-top div p {
  font-size: 24px;
  color: #ffffff;
  line-height: 45px;
}
/* 顶部背景图结束 */

/* 五大画像开始 */
.WuDaHuax {
  // height: 950px;
  background: #ffffff;
   padding-bottom: 50px;
}
.WuDaHuax > .Title {
  font-size: 35px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  text-align: center;
  padding: 70px 0 20px 0;
}
.WuDaHuax > .div {
  display: flex;
}

.WuDaHuax > .div .div1,
.WuDaHuax > .div .div6 {
  flex: 1;
  margin: 0 17px;
}
.WuDaHuax > .div .div2 {
  margin:  0px auto;
  margin-top: 20px;
  width: 1249px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  .partner {
    width: 388px;
    height: 212px;
    margin: 10px;
    align-items:center;
    img {
      width: 388px;
      height: 212px;
    }
  }
}
// .WuDaHuax {
//   height: 1132px;
//   color: #333333;
//   background: #ffffff;
// }
// .WuDaHuax > .Title {
//   font-size: 35px;
//   font-family: Microsoft YaHei;
//   font-weight: 400;
//   color: #000000;
//   text-align: center;
//   padding: 70px 0 50px 0;
// }
// .WuDaHuax > .div {
//   display: flex;
//   padding: 0 5%;
//   justify-content: space-between;
// }

// .WuDaHuax > .div .div0 {
//   flex: 1;
//   padding: 0 20px;
// }
// .WuDaHuax > .div .div1 {
//   padding: 0 20px;
//   padding-top: 40px;
//   width: 212px;
//   height: 833px;
//   margin: 0 20px;
//   background: #ffffff;
//   box-shadow: 0px 1px 17px 1px rgba(93, 93, 93, 0.13);
//   border-radius: 15px;
//   font-family: Microsoft YaHei;
// font-weight: 400;
// }
// .WuDaHuax > .div .div1 .div1-1 {
//   text-align: center;
//   font-size: 24px;
//   color: #373d41;
//   line-height: 45px;
//   margin-bottom: 20px;
// }

// .WuDaHuax > .div .div1 .div1-1 img {
//   width: 92px;
//   height: 84px;
//   vertical-align: middle;
//   margin-bottom: 16px;
// }
// .WuDaHuax > .div .div1 .div1-2 {
//   text-align: center;
// font-size: 16px;
// color: #373D41;
// }
// .WuDaHuax > .div .div1 .div1-2 ul li{
//   line-height: 28px;
// }
/* 五大画像结束 */
/* 产融科技八大核心能力开始 */
.crkjBdHxnl {
  height: 950px;
  background: #f5f7fa;
}
.crkjBdHxnl > .Title {
  font-size: 35px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  text-align: center;
  padding: 70px 0 20px 0;
}
.crkjBdHxnl > .div {
  display: flex;
}

.crkjBdHxnl > .div .div1,
.crkjBdHxnl > .div .div6 {
  flex: 1;
  margin: 0 17px;
}
.crkjBdHxnl > .div .div2 {
  margin-top: 50px;
  width: 1249px;
  height: 675px;
  background: url("../../assets/crTechnology/crkjbdhxnl.png") center center no-repeat;
}
/* 产融科技八大核心能力结束 */
/* 供应链1+N+1结构穿透开始 */
.gylJiaJgct {
  height: 980px;
  background: #ffffff;
}
.gylJiaJgct > .Title {
  font-size: 35px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  text-align: center;
  padding: 70px 0 20px 0;
}
.gylJiaJgct > .div {
  display: flex;
}

.gylJiaJgct > .div .div1,
.gylJiaJgct > .div .div6 {
  flex: 1;
  margin: 0 17px;
}
.gylJiaJgct > .div .div2 {
  margin-top: 20px;
  width: 1231px;
  height: 762px;
  background: url("../../assets/crTechnology/gyljiajgct.png") center center no-repeat;
}
/* 供应链1+N+1结构穿透结束 */
</style>
